import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { IdiomaService } from 'src/app/core/services/idioma.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimpleModalComponent } from 'src/app/shared/modals/simple-modal/simple-modal.component';
import { ApiService } from 'src/app/core/services/api.service';
import { OnExecuteData, OnExecuteErrorData, ReCaptchaV3Service } from 'ng-recaptcha';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
  selector: 'app-teste-canais-contato',
  templateUrl: './teste-canais-contato.component.html',
  styleUrls: ['./teste-canais-contato.component.scss']
})

export class TesteCanaisContatoComponent implements OnInit, OnDestroy {
  data: any;

  idiomaSelecionado;
  idiomas;
  formatExtra;
  emlExtra;

  formGroup: FormGroup;

  jsonFormatado;

  public recentToken = '';
  public recentError?: { error: any };
  public readonly executionLog: Array<OnExecuteData | OnExecuteErrorData> = [];

  private allExecutionsSubscription: Subscription;
  private allExecutionErrorsSubscription: Subscription;
  private singleExecutionSubscription: Subscription;

  constructor(
    private translate: TranslateService,
    private idiomaService: IdiomaService,
    private titleService: Title,
    private meta: Meta,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private modalService: NgbModal,
    private recaptchaV3Service: ReCaptchaV3Service,
    private gaService: GoogleAnalyticsService,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute
  ) {
    this.carregarFormGroup();

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.carregarDados();
      this.idiomaSelecionado = this.idiomaService.getIdioma();
    });
  }

  ngOnInit() {
    this.carregarDados();

    this.idiomaSelecionado = this.idiomaService.getIdioma();
    this.idiomas = this.idiomaService.getIdiomas();

    this.allExecutionsSubscription = this.recaptchaV3Service.onExecute
    .subscribe((data) => this.executionLog.push(data));
    
    this.allExecutionErrorsSubscription = this.recaptchaV3Service.onExecuteError
    .subscribe((data) => this.executionLog.push(data));

    this.renderer.addClass(document.body, 'recaptcha');

    this.activatedRoute.queryParams.subscribe(params => {
      var paramFormatExtra = params['formatExtra'];
      if(paramFormatExtra != undefined){
        this.formatExtra = paramFormatExtra.replace(/:/g,'#').split(";");
      }
      var paramEmlExtra = params['emlExtra'];
      if(paramEmlExtra != undefined){
        this.emlExtra = paramEmlExtra.replace(/:/g,'#').split(';');
      }
    });
  }

  ngOnDestroy() {
    if (this.allExecutionsSubscription) {
      this.allExecutionsSubscription.unsubscribe();
    }
    if (this.allExecutionErrorsSubscription) {
      this.allExecutionErrorsSubscription.unsubscribe();
    }
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }

    this.renderer.removeClass(document.body, 'recaptcha');
  }

  carregarDados() {
    this.translate.get('TESTE_CANAIS_CONTATO').subscribe(res => {
      this.data = res;
      this.titleService.setTitle(this.data.HEADER_TITLE);
      this.meta.updateTag({name: 'description', content: this.data.META_DESCRIPTION});
      this.meta.updateTag({name: 'keywords', content:  this.data.META_KEYWORDS});
      this.gaService.pageView(this.router.url);
    });
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNome: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        )),
        formCelular: new FormControl('', [Validators.required, Validators.maxLength(18)]),
        formTemplateFormat: new FormControl('', Validators.required),
        formTemplateEmail:  new FormControl('', Validators.required)
       }
    );
  }

  public formatToken(token: string): string {
    if (!token) {
      return '(empty)';
    }
    return `${token.substr(0, 7)}...${token.substr(-7)}`;
  }

  onSubmit() {
    if (this.singleExecutionSubscription) {
      this.singleExecutionSubscription.unsubscribe();
    }
    this.singleExecutionSubscription = this.recaptchaV3Service.execute('teste_envio')
      .subscribe(
        (token) => {
          this.recentToken = token;
          this.recentError = undefined;

          this.apiService.demoEnvio(
            this.recentToken,
            this.formGroup.get('formNome').value,
            this.formGroup.get('formEmail').value,
            this.formGroup.get('formCelular').value,
            this.formGroup.get('formTemplateFormat').value,
            this.formGroup.get('formTemplateEmail').value
          )
            .subscribe(
              res => {
                const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
                modalRef.componentInstance.message = this.data.MENSAGEM_SUCESSO;
                                
                this.jsonFormatado =  '{'
                + '\n'
                + ' "NOME": ' + '\"' + this.formGroup.get('formNome').value + '\",\n'
                + ' "EMAIL": ' + '\"' + this.formGroup.get('formEmail').value + '\",\n'
                + ' "CELULAR": ' + '\"' + this.formGroup.get('formCelular').value + '\",\n'
                + ' "TEMPLATE_FORMAT_ID": ' + '\"' + this.formGroup.get('formTemplateFormat').value + '\",\n'
                + ' "TEMPLATE_EMAIL_ID": ' + '\"' + this.formGroup.get('formTemplateEmail').value + '\"'
                + '\n'
                + '}';
              },
              err => {
                let message;
                if (err != null && err.error != null) {
                  message = err.error;
                } else {
                  message =  this.data.MENSAGEM_ERRO;
                }
                const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
                modalRef.componentInstance.message = message;
                this.formGroup.reset();
              }
            );
        },
        (error) => {
          this.recentToken = '';
          this.recentError = { error };

          const modalRef = this.modalService.open(SimpleModalComponent, { windowClass: 'xlModal', centered: true });
          modalRef.componentInstance.message = this.recentError;
          this.formGroup.reset();
        },
      );
  }

  limpar() {
    this.formGroup.reset();
    this.jsonFormatado = null;
  }

  alterarIdioma(idioma) {
    this.translate.use(idioma);
  }
}
